import React, { useEffect, useMemo } from 'react';
import { Outlet, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Loader from '../loader';
import { chkAccAct, fetchCabpAct, setProfile } from '../redux/profile/profileActions';
import { fetchPrjAsn } from '../redux/prjasn/prjAsnActions';
import { fetchLookupAct } from '../redux/ctrl/ctrlActions';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { setGetIdTokenClaims, setLoginWithRedirect } from '../../utils/auth';

const SecureRoute = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const datasetsLkp = useSelector((state) => state.ctrl.datasetsLkp);
  const destroyed = useSelector((state) => state.ctrl.destroyedGrid);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const isImpactPartnerRoute = useMemo(
    () => location.pathname.includes('punchout'),
    [location.pathname]
  )

  const { isAuthenticated, isLoading, loginWithRedirect, user, getIdTokenClaims } = useAuth0();
  const [searchParams] = useSearchParams();

  useEffect(() => {

    if (getIdTokenClaims) {
      setGetIdTokenClaims(getIdTokenClaims);
    }

    if (loginWithRedirect) {
      setLoginWithRedirect(loginWithRedirect);
    }

    if (!isLoading && !isAuthenticated) {
      const screenHint = searchParams.get('screen_hint');
      const loginHint = searchParams.get('login_hint');
      const returnTo = searchParams.get('returnTo');

      const authorizationParams = {
        "ext-redirectURI": window.location.origin,
        "ext-returnPath": "/",
      };

      if (screenHint) {
        authorizationParams.screen_hint = screenHint;
      }

      if (loginHint) {
        authorizationParams.login_hint = loginHint;
      }

      loginWithRedirect({
        authorizationParams,
        appState: {
          returnTo: returnTo || location.pathname + location.search,
        },
      });
    }

    if (isAuthenticated && user && !profile.email) {
      dispatch(setProfile({
        email: user.email,
        family_name: user.last_name,
        given_name: user.first_name,
        name: user.name,
      }));
      dispatch(chkAccAct(user.email))
      dispatch(fetchCabpAct(user.email))
      if (!isImpactPartnerRoute) {
        navigate('/');
      }
    }
  }, [isLoading, isAuthenticated, location, profile.email, getIdTokenClaims]);

  useEffect(() => {

    if (!profile.email) {
      return;
    }

    if (isImpactPartnerRoute) {
      dispatch(fetchLookupAct([
        'EMR PROJECT WORKSPACE TECHNOLOGY TYPE',
        'EMR PRJWSC BU OFFICE LIST',
        'EMR PRJWSC PRICELIST',
        'EMR PRJWSC TEMPLATES'
      ]))
    }

    if (profile.appAcc.length && profile.appAcc[0].access_exist == 'Y' && !isImpactPartnerRoute) {
      dispatch(fetchPrjAsn())

      dispatch(
        fetchLookupAct([
          'EMR PROJECT WORKSPACE TECHNOLOGY TYPE',
          'EMR WORLD AREA SALES ORG',
          'EMR PROJECT WORKSPACE CATEGORIES',
          'EMR PROJECT WORKSPACE COMMON COLUMNS',
          'EMR PROJECT WORKSPACE DP FLOW COLUMNS',
          'EMR PROJECT WORKSPACE FLOW COLUMNS',
          'EMR PROJECT WORKSPACE PRESSURE COLUMNS',
          'EMR PROJECT WORKSPACE TEMPERATURE COLUMNS',
          'EMR PROJECT WORKSPACE DP LEVEL COLUMNS',
          'EMR PROJECT WORKSPACE PROCESS LEVEL COLUMNS',
          'EMR PROJECT WORKSPACE VANESSA COLUMNS',
          'EMR PRJWSC BU OFFICE LIST',
          'EMR PRJWSC PRICELIST',
          'EMR PROJECT WORKSPACE DOC & ORD SERVICES COLUMNS',
          'EMR PROJECT WORKSPACE BUY RESALE COLUMNS',
          'EMR PROJECT WORKSPACE SPARES COLUMNS',
          'EMR PROJECT WORKSPACE FLAME & GAS COLUMNS',
          //'EMR PROJECT WORKSPACE PRODUCT TYPE MAP'
          'EMR PROJECT WORKSPACE ALL INSTRUMENTATION COLUMNS',
          'EMR PRJWSC TEMPLATES',
          'EMR PRJWSC SALES CHANNEL NAME'
        ])
      )
    }
  }, [profile.email, profile.appAcc]);

  useEffect(() => {
    if (datasetsLkp) {
      const dispatchDebounce = setTimeout(() => {
        Object.values(datasetsLkp).map((lk) => {
          lk.map((lkp) => {
            lkp.meaning = t(lkp.description);
          })
        })
      }, 2000);
      return () => {
        clearTimeout(dispatchDebounce);
      };
    }
  }, [datasetsLkp, destroyed]);

  if (isLoading || !isAuthenticated) {
    return <Loader />;
  }

  return <Outlet />;

}

export default SecureRoute

